module.exports = __webpack_public_path__ + "img/slide01_m.63d3d561.jpg";